import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Popover, Transition } from '@headlessui/react';
import NcInputNumber from 'components/NcInputNumber/NcInputNumber';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import ButtonThird from 'shared/Button/ButtonThird';
import ButtonClose from 'shared/ButtonClose/ButtonClose';
import Checkbox from 'shared/Checkbox/Checkbox';
import { Range } from 'rc-slider';
import convertNumbThousand from 'utils/convertNumbThousand';
import { ChevronDownIcon } from '@heroicons/react/solid';

import { PropertiesContext } from 'context/PropertiesContext';
import {
  getConditions,
  getExtras,
  getAllProperties,
} from 'data/DataController';

let sortData = [
  { id: 'date-asc', title: 'Date Old to New' },
  { id: 'date-desc', title: 'Date New to Old' },
  { id: 'price-asc', title: 'Price Low to High' },
  { id: 'price-desc', title: 'Price High to Low' },
  { id: 'size-asc', title: 'Size Lowest to Largest' },
  { id: 'size-desc', title: 'Size Largest to Lowest' },
];

const defaultMinArea = 1;
const defaultMaxArea = 300;
const defaultBedrooms = 1;
const defaultBathrooms = 1;
// @ts-ignore
const defaultConditions = [];
// @ts-ignore
const defaultExtras = [];

// where string is the lang

// export function sortByData(strings){
// 	let data = [
// 	{id:'date-asc', title: strings.ST70},
// 	{id:'date-desc', title: strings.ST89},
// 	{id:'price-asc', title: strings.ST71},
// 	{id:'price-desc', title: strings.ST72},
// 	{id:'size-asc', title: strings.ST91},
// 	{id:'size-desc', title: strings.ST90}
// 	];
// 	return data;
// };

// const [bedRef, setBedRef] = useState(null);

const TabFilters = () => {
  const PropertiesContextState = React.useContext(PropertiesContext);
  // const searchQuery = PropertiesContextState.searchQuery;
  // console.log('Search query: ');
  // console.log(searchQuery);

  useEffect(() => {
    const searchQuery = PropertiesContextState.searchQuery;
    // console.log('Search query Inside useEff: ');
    // console.log(searchQuery);
  }, []);

  const [language, setLanguage] = useState(PropertiesContextState.language);
  console.log('Tabfilters set with lang: ' + PropertiesContextState.language);
  const [condition, setCondition] = useState('');
  const [extras, setExtras] = useState('');

  const [minarea, setMinArea] = useState([]);
  const [showMinArea, setShowMinArea] = useState(false);
  const [maxarea, setMaxArea] = useState([]);
  const [showMaxArea, setShowMaxArea] = useState(false);

  const [orderByState, setOrderByState] = useState('Sort By');

  const [bedrooms, setBedrooms] = useState(defaultBedrooms);
  const [bathrooms, setBathrooms] = useState(defaultBathrooms);

  const [selectedConditions, setSelectedConditions] =
    // @ts-ignore
    useState(defaultConditions);
  // @ts-ignore
  const [selectedExtras, setSelectedExtras] = useState(defaultExtras);

  // useEffect(() => {
  //   function getCookie(key: string) {
  //     var b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
  //     return b ? b.pop() : '';
  //   }
  //   if (getCookie('siteLang') !== undefined && getCookie('siteLang') !== '') {
  //     /* @ts-ignore */
  //     setLanguage(getCookie('siteLang'));
  //     console.log('Site lang cookie is set to: ' + getCookie('siteLang'));
  //   } else {
  //     setLanguage('en');
  //   }
  // }, []);

  useEffect(() => {
    console.log('Language is changed! (Tabfilters) : ' + language);
  }, [language]);

  useEffect(() => {
    getConditions(language).then((response: any) => {
      // console.log(response);
      setCondition(response);

      // console.log('conditions setted with language: ');
      // console.log(language);

      // console.log('conditions setted with: ');
      // console.log(response);
    });
  }, [language]);

  useEffect(() => {
    getExtras(language).then((response: any) => {
      // console.log(response);
      setExtras(response);

      // console.log('extras setted with: ');
      // console.log(response);
    });
  }, [language]);

  const [isOpenMoreFilter, setisOpenMoreFilter] = useState(false);
  const [isOpenMoreFilterMobile, setisOpenMoreFilterMobile] = useState(false);
  // const [rangePrices, setRangePrices] = useState([0, 1000]);

  //
  const closeModalMoreFilter = () => {
    setisOpenMoreFilter(false);
    applyFilters();
  };
  const closeModalMoreFilterOnClear = () => {
    setisOpenMoreFilter(false);
    resetFilters();
  };
  const openModalMoreFilter = () => setisOpenMoreFilter(true);
  //
  const closeModalMoreFilterMobile = () => {
    setisOpenMoreFilterMobile(false);
    applyFilters();
  };
  const closeModalMoreFilterMobileOnClear = () => {
    setisOpenMoreFilterMobile(false);
    resetFilters();
  };
  const openModalMoreFilterMobile = () => setisOpenMoreFilterMobile(true);

  // const [rangePrices, setRangePrices] = useState([20, 100]);
  const [rangeArea, setRangeArea] = useState([10, 300]);

  const applyFilters = () => {
    console.log({
      minarea: rangeArea[0],
      maxarea: rangeArea[1],
      bedrooms: bedrooms,
      bathrooms: bathrooms,
      condition: selectedConditions,
      extras: selectedExtras,
    });
    getAllProperties({
      ...PropertiesContextState.searchQuery,
      minarea: rangeArea[0],
      maxarea: rangeArea[1],
      bedrooms: bedrooms,
      bathrooms: bathrooms,
      condition: selectedConditions,
      extras: selectedExtras,
    }).then((response) => {
      console.log(response);
      PropertiesContextState.setContext({
        results: response,
        searchQuery: {
          ...PropertiesContextState.searchQuery,
          minarea: rangeArea[0],
          maxarea: rangeArea[1],
          bedrooms: bedrooms,
          bathrooms: bathrooms,
          condition: selectedConditions,
          extras: selectedExtras,
        },
      });
    });
  };

  const resetFilters = () => {
    setRangeArea([defaultMinArea, defaultMaxArea]);
    setBathrooms(defaultBathrooms);
    setBedrooms(defaultBedrooms);
    // @ts-ignore
    setSelectedConditions(defaultConditions);
    // @ts-ignore
    setSelectedExtras(defaultExtras);

    getAllProperties({
      ...PropertiesContextState.searchQuery,
      minarea: defaultMinArea,
      maxarea: defaultMaxArea,
      bedrooms: defaultBedrooms,
      bathrooms: defaultBathrooms,
      // @ts-ignore
      condition: defaultConditions,
      // @ts-ignore
      extras: defaultExtras,
    }).then((response) => {
      console.log(response);
      PropertiesContextState.setContext({
        results: response,
        searchQuery: {
          ...PropertiesContextState.searchQuery,
          minarea: defaultMinArea,
          maxarea: defaultMaxArea,
          bedrooms: defaultBedrooms,
          bathrooms: defaultBathrooms,
          // @ts-ignore
          condition: defaultConditions,
          // @ts-ignore
          extras: defaultExtras,
        },
      });
    });
  };

  const renderXClear = () => {
    return (
      <span className='w-4 h-4 rounded-full bg-primary-500 text-white flex items-center justify-center ml-3 cursor-pointer'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='h-3 w-3'
          viewBox='0 0 20 20'
          fill='currentColor'
        >
          <path
            fillRule='evenodd'
            d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
            clipRule='evenodd'
          />
        </svg>
      </span>
    );
  };

  // const renderTabsTypeOfPlace = () => {
  //   return (
  //     <Popover className='relative'>
  //       {({ open, close }) => (
  //         <>
  //           <Popover.Button
  //             className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 focus:outline-none ${
  //               open ? '!border-primary-500 ' : ''
  //             }`}
  //           >
  //             <span>Type of place</span>
  //             <i className='las la-angle-down ml-2'></i>
  //           </Popover.Button>
  //           <Transition
  //             as={Fragment}
  //             enter='transition ease-out duration-200'
  //             enterFrom='opacity-0 translate-y-1'
  //             enterTo='opacity-100 translate-y-0'
  //             leave='transition ease-in duration-150'
  //             leaveFrom='opacity-100 translate-y-0'
  //             leaveTo='opacity-0 translate-y-1'
  //           >
  //             <Popover.Panel className='absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md'>
  //               <div className='overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700'>
  //                 <div className='relative flex flex-col px-5 py-6 space-y-5'>
  //                   {typeOfPaces.map((item) => (
  //                     <div key={item.name} className=''>
  //                       <Checkbox
  //                         name={item.name}
  //                         label={item.name}
  //                         subLabel={item.description}
  //                       />
  //                     </div>
  //                   ))}
  //                 </div>
  //                 <div className='p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between'>
  //                   <ButtonThird onClick={close} sizeClass='px-4 py-2 sm:px-5'>
  //                     Clear
  //                   </ButtonThird>
  //                   <ButtonPrimary
  //                     onClick={close}
  //                     sizeClass='px-4 py-2 sm:px-5'
  //                   >
  //                     Apply
  //                   </ButtonPrimary>
  //                 </div>
  //               </div>
  //             </Popover.Panel>
  //           </Transition>
  //         </>
  //       )}
  //     </Popover>
  //   );
  // };

  // const renderTabsRoomAndBeds = () => {
  //   return (
  //     <Popover className='relative'>
  //       {({ open, close }) => (
  //         <>
  //           <Popover.Button
  //             className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-neutral-300 dark:border-neutral-700 focus:outline-none ${
  //               open ? '!border-primary-500 ' : ''
  //             }`}
  //           >
  //             <span>Rooms of Beds</span>
  //             <i className='las la-angle-down ml-2'></i>
  //           </Popover.Button>
  //           <Transition
  //             as={Fragment}
  //             enter='transition ease-out duration-200'
  //             enterFrom='opacity-0 translate-y-1'
  //             enterTo='opacity-100 translate-y-0'
  //             leave='transition ease-in duration-150'
  //             leaveFrom='opacity-100 translate-y-0'
  //             leaveTo='opacity-0 translate-y-1'
  //           >
  //             <Popover.Panel className='absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md'>
  //               <div className='overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900   border border-neutral-200 dark:border-neutral-700'>
  //                 <div className='relative flex flex-col px-5 py-6 space-y-5'>
  //                   <NcInputNumber label='Beds' max={10} />
  //                   <NcInputNumber label='Bedrooms' max={10} />
  //                   <NcInputNumber label='Bathrooms' max={10} />
  //                 </div>
  //                 <div className='p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between'>
  //                   <ButtonThird onClick={close} sizeClass='px-4 py-2 sm:px-5'>
  //                     Clear
  //                   </ButtonThird>
  //                   <ButtonPrimary
  //                     onClick={close}
  //                     sizeClass='px-4 py-2 sm:px-5'
  //                   >
  //                     Apply
  //                   </ButtonPrimary>
  //                 </div>
  //               </div>
  //             </Popover.Panel>
  //           </Transition>
  //         </>
  //       )}
  //     </Popover>
  //   );
  // };

  const renderConditions = (
    data: {
      id: number;
      title: string;
      defaultChecked?: boolean;
    }[]
  ) => {
    const list1 = data.filter((_, i) => i < data.length / 2);
    const list2 = data.filter((_, i) => i >= data.length / 2);
    return (
      <div className='grid grid-cols-2 gap-8'>
        <div className='flex flex-col space-y-5'>
          {list1.map((item) => (
            // console.log('list1: '),
            // console.log(list1),
            // console.log('item :' + item.title, 'item id :' + item.id),
            // console.log(
            //   'checkbox re evaultaes with condiitons: ' + selectedConditions
            // ),
            // console.log(
            //   selectedConditions?.filter(function (val) {
            //     return val === item.id;
            //   }).length > 0
            // ),
            // console.log(list1),
            // console.log(item),
            <Checkbox
              key={item.id}
              name={item.title}
              label={item.title}
              defaultChecked={
                selectedConditions?.filter(function (val) {
                  return val === item.id;
                }).length > 0
                // @ts-ignore
                // selectedConditions.includes(item.id)
              }
              onChange={(e) => {
                const itemId = item.id;
                if (e === true) {
                  console.log('set selected condition is true');
                  /* @ts-ignore */
                  setSelectedConditions((prevState: any) => [
                    ...prevState,
                    itemId,
                  ]);
                } else if (e === false) {
                  //console.log(item.id);
                  // console.log('set selected condition is false');
                  // console.log('Inside: ');
                  // console.log(typeof selectedConditions);
                  // console.log(selectedConditions);
                  // console.log(itemId);
                  // console.log(selectedConditions?.filter((item) => item));
                  setSelectedConditions(
                    selectedConditions?.filter((item) => item !== itemId)
                  );
                  // onChangeParent(item.id);
                }
              }}
            />
          ))}
        </div>
        <div className='flex flex-col space-y-5'>
          {list2.map((item) => (
            <Checkbox
              key={item.id}
              name={item.title}
              label={item.title}
              defaultChecked={
                selectedConditions?.filter(function (val) {
                  return val === item.id;
                }).length > 0
              }
              onChange={(e) => {
                const itemId = item.id;
                if (e === true) {
                  /* @ts-ignore */
                  setSelectedConditions((prevState: any) => [
                    ...prevState,
                    itemId,
                  ]);
                } else if (e === false && selectedConditions) {
                  console.log('Inside: ');
                  console.log(selectedConditions);
                  console.log(itemId);
                  console.log(selectedConditions?.filter((item) => item));
                  //console.log(item.id);
                  setSelectedConditions(
                    selectedConditions?.filter((item) => item !== itemId)
                  );
                  // onChangeParent(item.id);
                }
              }}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderExtras = (
    data: {
      id: number;
      title: string;
      defaultChecked?: boolean;
    }[]
  ) => {
    const list1 = data.filter((_, i) => i < data.length / 2);
    const list2 = data.filter((_, i) => i >= data.length / 2);
    return (
      <div className='grid grid-cols-2 gap-8'>
        <div className='flex flex-col space-y-5'>
          {list1.map((item) => (
            // console.log('list1: '),
            // console.log(list1),
            // console.log('item :' + item.title, 'item id :' + item.id),
            <Checkbox
              key={item.id}
              name={item.title}
              label={item.title}
              defaultChecked={
                selectedExtras?.filter(function (val) {
                  return val === item.id;
                }).length > 0
              }
              onChange={(e) => {
                const itemId = item.id;
                if (e === true) {
                  /* @ts-ignore */
                  setSelectedExtras((prevState: any) => [...prevState, itemId]);
                } else if (e === false && selectedExtras) {
                  //console.log(item.id);
                  setSelectedExtras(
                    selectedExtras?.filter((item) => item !== itemId)
                  );
                  // onChangeParent(item.id);
                }
              }}
            />
          ))}
        </div>
        <div className='flex flex-col space-y-5'>
          {list2.map((item) => (
            <Checkbox
              key={item.id}
              name={item.title}
              label={item.title}
              defaultChecked={
                selectedExtras?.filter(function (val) {
                  return val === item.id;
                }).length > 0
              }
              onChange={(e) => {
                const itemId = item.id;
                if (e === true) {
                  /* @ts-ignore */
                  setSelectedExtras((prevState: any) => [...prevState, itemId]);
                } else if (e === false && selectedExtras) {
                  //console.log(item.id);
                  setSelectedExtras(
                    selectedExtras?.filter((item) => item !== itemId)
                  );
                  // onChangeParent(item.id);
                }
              }}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderTabMoreFilter = () => {
    return (
      <div>
        <div
          className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border border-primary-500 bg-primary-50 text-primary-700 focus:outline-none cursor-pointer`}
          onClick={openModalMoreFilter}
        >
          <span>More filters</span>
          {renderXClear()}
        </div>

        <Transition appear show={isOpenMoreFilter} as={Fragment}>
          <Dialog
            as='div'
            className='fixed inset-0 z-50 overflow-y-auto'
            onClose={closeModalMoreFilter}
          >
            <div className='min-h-screen text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0'
                enterTo='opacity-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'
              >
                <Dialog.Overlay className='fixed inset-0 bg-black bg-opacity-40 dark:bg-opacity-60' />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className='inline-block h-screen align-middle'
                aria-hidden='true'
              >
                &#8203;
              </span>
              <Transition.Child
                className='inline-block py-8 h-screen w-full'
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <div className='inline-flex flex-col w-full max-w-4xl text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full'>
                  <div className='relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center'>
                    <Dialog.Title
                      as='h3'
                      className='text-lg font-medium leading-6 text-gray-900'
                    >
                      More filters
                    </Dialog.Title>
                    <span className='absolute left-3 top-3'>
                      <ButtonClose onClick={closeModalMoreFilter} />
                    </span>
                  </div>

                  <div className='flex-grow overflow-y-auto'>
                    <div className='px-10 divide-y divide-neutral-200 dark:divide-neutral-800'>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Floor Area</h3>
                        <div className='mt-6 relative '>
                          <div className='relative flex flex-col space-y-8'>
                            <div className='space-y-5'>
                              <Range
                                className='text-red-400'
                                min={1}
                                max={300}
                                defaultValue={[rangeArea[0], rangeArea[1]]}
                                value={[rangeArea[0], rangeArea[1]]}
                                allowCross={false}
                                step={1}
                                onChange={setRangeArea}
                                // onAfterChange={setRangeArea}
                              />
                            </div>

                            <div className='flex justify-between space-x-5'>
                              <div>
                                <label
                                  htmlFor='minPrice'
                                  className='block text-sm font-medium text-neutral-700 dark:text-neutral-300'
                                >
                                  Min area
                                </label>
                                <div className='mt-1 relative rounded-md'>
                                  <div className='absolute inset-y-0 right-4 pl-3 flex items-center pointer-events-none'>
                                    <span className='text-neutral-500 sm:text-sm'>
                                      m²
                                    </span>
                                  </div>
                                  <input
                                    type='number'
                                    name='minPrice'
                                    id='minPrice'
                                    className='focus:ring-primary-500 focus:border-primary-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900'
                                    value={rangeArea[0]}
                                    onChange={(e) =>
                                      setRangeArea([
                                        parseInt(e.target.value),
                                        rangeArea[1],
                                      ])
                                    }
                                  />
                                </div>
                              </div>
                              <div>
                                <label
                                  htmlFor='maxPrice'
                                  className='block text-sm font-medium text-neutral-700 dark:text-neutral-300'
                                >
                                  Max area
                                </label>
                                <div className='mt-1 relative rounded-md'>
                                  <div className='absolute inset-y-0 right-4 pl-3 flex items-center pointer-events-none'>
                                    <span className='text-neutral-500 sm:text-sm'>
                                      m²
                                    </span>
                                  </div>
                                  <input
                                    type='number'
                                    name='maxPrice'
                                    id='maxPrice'
                                    className='focus:ring-primary-500 focus:border-priring-primary-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900'
                                    value={rangeArea[1]}
                                    onChange={(e) =>
                                      setRangeArea([
                                        rangeArea[0],
                                        parseInt(e.target.value),
                                      ])
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className='py-7'>
                        <h3 className='text-xl font-medium'>Amenities</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter1)}
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Facilities</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter2)}
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Type of heating</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(heatingTypes)}
                        </div>
                      </div> */}
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Rooms and beds</h3>
                        <div className='mt-6 relative flex flex-col space-y-5'>
                          <NcInputNumber
                            label='Bedrooms'
                            defaultValue={bedrooms}
                            max={10}
                            onChange={(bedrooms) => {
                              setBedrooms(bedrooms);
                            }}
                          />
                          <NcInputNumber
                            label='Bathrooms'
                            defaultValue={bathrooms}
                            max={10}
                            onChange={(baths) => {
                              setBathrooms(baths);
                            }}
                          />
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Conditions</h3>
                        <div className='mt-6 relative '>
                          {/* @ts-ignore */}
                          {condition && renderConditions(condition)}
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Extras</h3>
                        <div className='mt-6 relative '>
                          {/* @ts-ignore */}
                          {extras && renderExtras(extras)}
                        </div>
                      </div>

                      {/* <div className='py-7'>
                        <h3 className='text-xl font-medium'>Property type</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter3)}
                        </div>
                      </div> */}
                      {/* <div className='py-7'>
                        <h3 className='text-xl font-medium'>House rules</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter4)}
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className='p-6 flex-shrink-0 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between'>
                    <ButtonThird
                      onClick={() => {
                        closeModalMoreFilterOnClear();
                      }}
                      sizeClass='px-4 py-2 sm:px-5'
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={closeModalMoreFilter}
                      sizeClass='px-4 py-2 sm:px-5'
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  };

  const renderTabMoreFilterMobile = () => {
    return (
      <div>
        <div
          className={`flex lg:hidden items-center justify-center px-4 py-2 text-sm rounded-full border border-primary-500 bg-primary-50 text-primary-700 focus:outline-none cursor-pointer`}
          onClick={openModalMoreFilterMobile}
        >
          <span>More filters</span>
          {renderXClear()}
        </div>

        <Transition appear show={isOpenMoreFilterMobile} as={Fragment}>
          <Dialog
            as='div'
            className='fixed inset-0 z-50 overflow-y-auto'
            onClose={closeModalMoreFilterMobile}
          >
            <div className='min-h-screen text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0'
                enterTo='opacity-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'
              >
                <Dialog.Overlay className='fixed inset-0 bg-black bg-opacity-40 dark:bg-opacity-60' />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className='inline-block h-screen align-middle'
                aria-hidden='true'
              >
                &#8203;
              </span>
              <Transition.Child
                className='inline-block py-8 h-screen w-full'
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <div className='inline-flex flex-col w-full max-w-4xl text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full'>
                  <div className='relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center'>
                    <Dialog.Title
                      as='h3'
                      className='text-lg font-medium leading-6 text-gray-900'
                    >
                      More filters
                    </Dialog.Title>
                    <span className='absolute left-3 top-3'>
                      <ButtonClose onClick={closeModalMoreFilterMobile} />
                    </span>
                  </div>

                  <div className='flex-grow overflow-y-auto'>
                    <div className='px-10 divide-y divide-neutral-200 dark:divide-neutral-800'>
                      {/* ---- */}
                      {/* <div className='py-7'>
                        <h3 className='text-xl font-medium'>Type of place</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(typeOfPaces)}
                        </div>
                      </div> */}

                      {/* ---- */}
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Floor Area</h3>
                        <div className='mt-6 relative '>
                          <div className='relative flex flex-col space-y-8'>
                            <div className='space-y-5'>
                              <Range
                                className='text-red-400'
                                min={1}
                                max={300}
                                defaultValue={[rangeArea[0], rangeArea[1]]}
                                value={[rangeArea[0], rangeArea[1]]}
                                allowCross={false}
                                step={1}
                                onChange={setRangeArea}
                              />
                            </div>

                            <div className='flex justify-between space-x-5'>
                              <div>
                                <label
                                  htmlFor='minPrice'
                                  className='block text-sm font-medium text-neutral-700 dark:text-neutral-300'
                                >
                                  Min area
                                </label>
                                <div className='mt-1 relative rounded-md'>
                                  <div className='absolute inset-y-0 right-3 pl-3 flex items-center pointer-events-none'>
                                    <span className='text-neutral-500 sm:text-sm'>
                                      m²
                                    </span>
                                  </div>
                                  <input
                                    type='number'
                                    name='minPrice'
                                    id='minPrice'
                                    className='focus:ring-primary-500 focus:border-primary-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900'
                                    value={rangeArea[0]}
                                    onChange={(e) =>
                                      setRangeArea([
                                        parseInt(e.target.value),
                                        rangeArea[1],
                                      ])
                                    }
                                  />
                                </div>
                              </div>
                              <div>
                                <label
                                  htmlFor='maxPrice'
                                  className='block text-sm font-medium text-neutral-700 dark:text-neutral-300'
                                >
                                  Max area
                                </label>
                                <div className='mt-1 relative rounded-md'>
                                  <div className='absolute inset-y-0 right-3 pl-3 flex items-center pointer-events-none'>
                                    <span className='text-neutral-500 sm:text-sm'>
                                      m²
                                    </span>
                                  </div>
                                  <input
                                    type='number'
                                    name='maxPrice'
                                    id='maxPrice'
                                    className='focus:ring-primary-500 focus:border-priring-primary-500 block w-full pl-7 pr-3 sm:text-sm border-neutral-200 rounded-full text-neutral-900'
                                    //value={convertNumbThousand(rangeArea[1])}
                                    value={rangeArea[1]}
                                    //onEnded={() => console.log('yes')}
                                    //onChange={(e) => setAreaMax(parseInt(e.target.value))}
                                    onChange={(e) =>
                                      setRangeArea([
                                        rangeArea[0],
                                        parseInt(e.target.value),
                                      ])
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---- */}
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>
                          Rooms and beds x
                        </h3>
                        <div className='mt-6 relative flex flex-col space-y-5'>
                          <NcInputNumber
                            label='Bedrooms'
                            defaultValue={bedrooms}
                            max={10}
                            onChange={(bedrooms) => {
                              setBedrooms(bedrooms);
                            }}
                            /* @ts-ignore */
                            // ref={setBedRef}
                          />
                          <NcInputNumber
                            label='Bathrooms'
                            defaultValue={bathrooms}
                            max={10}
                            onChange={(baths) => {
                              setBathrooms(baths);
                            }}
                          />
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Conditions</h3>
                        <div className='mt-6 relative '>
                          {/* @ts-ignore */}
                          {condition && renderConditions(condition)}
                        </div>
                      </div>
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Extras</h3>
                        <div className='mt-6 relative '>
                          {/* @ts-ignore */}
                          {extras && renderExtras(extras)}
                        </div>
                      </div>

                      {/* 
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Amenities</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter1)}
                        </div>
                      </div>

                     
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Facilities</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter2)}
                        </div>
                      </div>

                      
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>Property type</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter3)}
                        </div>
                      </div>

                     
                      <div className='py-7'>
                        <h3 className='text-xl font-medium'>House rules</h3>
                        <div className='mt-6 relative '>
                          {renderMoreFilterItem(moreFilter4)}
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className='p-6 flex-shrink-0 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between'>
                    <ButtonThird
                      onClick={() => {
                        closeModalMoreFilterMobileOnClear();
                      }}
                      sizeClass='px-4 py-2 sm:px-5'
                    >
                      Clear
                    </ButtonThird>
                    <ButtonPrimary
                      onClick={closeModalMoreFilterMobile}
                      sizeClass='px-4 py-2 sm:px-5'
                    >
                      Apply
                    </ButtonPrimary>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  };

  const renderSelectClass = () => {
    return (
      <div className=''>
        <Popover className='relative'>
          {({ open, close }) => (
            <>
              <Popover.Button
                className={`
           ${open ? '' : ''}
             rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-xs`}
              >
                <span>{`${orderByState}`}</span>
                <ChevronDownIcon
                  className={`${
                    open ? '' : 'text-opacity-70'
                  } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                  aria-hidden='true'
                />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter='transition ease-out duration-200'
                enterFrom='opacity-0 translate-y-1'
                enterTo='opacity-100 translate-y-0'
                leave='transition ease-in duration-150'
                leaveFrom='opacity-100 translate-y-0'
                leaveTo='opacity-0 translate-y-1'
              >
                <Popover.Panel className='absolute z-10 w-screen max-w-[200px] sm:max-w-[220px] px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 '>
                  <div className='overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 '>
                    <div className='relative grid gap-8 bg-white dark:bg-neutral-800 p-7 '>
                      {sortData.map((item) => (
                        <a
                          key={item.title}
                          onClick={(e) => {
                            /* TODO: call get proeprties overriden the context search query with selected sortby property */
                            e.preventDefault();
                            setOrderByState(item.title);
                            close();

                            // console.log({
                            //   ...PropertiesContextState.searchQuery,
                            //   sortby: item.id,
                            // });
                            // console.log(PropertiesContextState.searchQuery);
                            // console.log(
                            //   Object.values({
                            //     ...PropertiesContextState.searchQuery,
                            //     sortby: item.id,
                            //   })
                            // );
                            getAllProperties({
                              ...PropertiesContextState.searchQuery,
                              sortby: item.id,
                            }).then((response) => {
                              PropertiesContextState.setContext({
                                results: response,
                                searchQuery: {
                                  ...PropertiesContextState.searchQuery,
                                  sortby: item.id,
                                },
                              });
                            });
                          }}
                          className='flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50'
                        >
                          <p className='text-sm font-medium '>{item.title}</p>
                        </a>
                      ))}
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    );
  };

  return (
    <div className='flex justify-between'>
      <div className='hidden lg:flex justify-between space-x-4'>
        {/* {renderTabsTypeOfPlace()}
        {renderTabsPriceRage()}
        {renderTabsRoomAndBeds()} */}
        {renderTabMoreFilter()}
      </div>
      {renderTabMoreFilterMobile()}
      <div className='flex items-center px-4 py-2 text-sm rounded-full border text-primary-700 focus:outline-none cursor-pointer'>
        {renderSelectClass()}
      </div>
    </div>
  );
};

export default TabFilters;
